import OrderConfirmationPage from './OrderConfirmationPage';

export default OrderConfirmationPage;
